import { Component, OnInit, QueryList, TemplateRef, ViewChild, ViewChildren } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HierService } from "../../service/hier.service";
import swal from 'sweetalert2';
import { session } from '../../../../environments/environment.session';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { AreaMapService } from '../../service/area-map.service';
import { MatTableDataSource } from '@angular/material/table';
import { ExcelService } from '../../service/file-export.service'
import Swal from "sweetalert2";
import * as XLSX from 'xlsx';
import { NgForm } from '@angular/forms';
import { SpinnerService } from '../../../shared/spinner.service'

declare var $: any;


@Component({
  selector: 'app-zone-word-mapping',
  templateUrl: './zone-word-mapping.component.html',
  styleUrls: ['./zone-word-mapping.component.css']
})
export class ZoneWordMappingComponent implements OnInit {
  currentPage: number = 1;
  pageSize: number = 10;
  totalPages: number = 0;
  pageList: number[] = [5, 10, 20, 50, 100];
  totalRecords: number = 0;
searchText: string = '';
filteredZoneList: any[] = [];

  pagedZoneList: any[] = [];
  calculateTotalPages() {
    this.totalPages = Math.ceil(this.totalRecords / this.pageSize) || 1;
  }

paginateZoneList() {
  const start = (this.currentPage - 1) * this.pageSize;
  const end = start + this.pageSize;
  this.pagedZoneList = this.filteredZoneList.slice(start, end);
}

  getStartIndex(): number {
    return (this.currentPage - 1) * this.pageSize + 1;
  }

  getEndIndex(): number {
    return Math.min(this.currentPage * this.pageSize, this.totalRecords);
  }

  prevPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.paginateZoneList();
    }
  }

  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.paginateZoneList();
    }
  }

  changePageSize() {
    this.currentPage = 1;
    this.calculateTotalPages();
    this.paginateZoneList();
  }

  constructor(private embHierService: HierService, private tspinner: SpinnerService, private areaMap: AreaMapService, private excel: ExcelService, private modalService: NgbModal) {


  }

  obj: any = {}
  rela: any = []
  listDatasource: any = []
  listDisplayedColumns = ['id', 'zone', 'word', 'mohalla', 'action']
  @ViewChildren(MatPaginator) paginator = new QueryList<MatPaginator>();
  @ViewChildren(MatSort) sort = new QueryList<MatSort>();
  @ViewChild('f') form!: NgForm;
  ebillUser: any
  async ngOnInit() {
    this.ebillUser = JSON.parse(atob(session.erpUser));
    await this.getAreaMapData()
    await this.getProjectHierFromAccount()
    // console.log(this.getAreaMapData);
  }

  async list() {
    await this.getAreaMapData()
  }

  zoneList: any = []

  async getAreaMapData() {
    this.tspinner.show('Loading Area Maps', 'Please wait while data is loading...');

    let obj = { b_acct_id: this.ebillUser.b_acct_id }
    let resp: any = await this.areaMap.getAreaMapData(obj)
    if (resp['error'] == false) {
      this.zoneList = resp['data'];
          this.filteredZoneList = [...this.zoneList]; 

      this.totalRecords = this.zoneList.length;
      this.calculateTotalPages();
      this.paginateZoneList();
      console.log(this.zoneList);
      //  this.listDatasource=new MatTableDataSource(resp['data'])
      //  this.listDatasource.paginator = this.paginator.toArray()[0];
      //  this.listDatasource.sort = this.sort.toArray()[0];
    } else {
      swal.fire('Error', "Error while creating", 'error')
    }
    this.tspinner.hide();


  }
onSearchChange() {
  const keyword = this.searchText.trim().toLowerCase();

  if (keyword) {
    const filtered = this.zoneList.filter((item:any) =>
      item.zone?.toLowerCase().includes(keyword) ||
      item.word?.toLowerCase().includes(keyword)
    );

    this.filteredZoneList = filtered.length ? filtered : this.zoneList.slice(0, 5);
  } else {
    this.filteredZoneList = [...this.zoneList];
  }

  this.totalRecords = this.filteredZoneList.length;
  this.currentPage = 1;
  this.calculateTotalPages();
  this.paginateZoneList();
}


  projecthier: any = [];
  allZone: any = []
  allZoneObj: any = {}
  async getProjectHierFromAccount() {
    let obj: any = new Object();
    obj["b_acct_id"] = this.ebillUser.b_acct_id;
    obj["module_cd"] = "sdp";
    let resp = await this.embHierService.getprojectHierarchy(obj);
    console.log(resp);
    for (let i = 0; i < resp.data.length; i++) {
      if (resp.data[i]["lvl1_cd"] == 1) {
        resp.data[i]["lvl1_value"] = "sdp-root";
      }
    }
    if (resp["error"] == false) {
      this.projecthier = resp["data"];
      this.allZone = []
      for (let i = 0; i < resp["data"].length; i++) {
        console.log(resp.data);
        if (resp["data"][i]["leaf_node_type"] == 'zone') {
          for (let j = 1; j < 8; j++) {
            if (resp["data"][i]["lvl" + j + "_node_type"] == 'zone') {
              this.allZoneObj[resp["data"][i]["lvl" + j + "_user_cd"]] = { zone: resp["data"][i]["lvl" + j + "_value"], leaf_cd: resp["data"][i]["lvl" + j + "_cd"] }
              this.allZone.push({ value: resp["data"][i]["lvl" + j + "_value"], code: resp["data"][i]["lvl" + j + "_user_cd"] })
            }
          }
        }
      }

    } else {
      swal.fire("Error...", "Error While Getting Cost Center", "error");
    }
  }


  resert(vale: string) {
    if (vale == 'map') {
      this.mapFlag = true
      this.excelFlag = false;
      this.listFlag = false
      return
    } else if (vale == 'excel') {
      this.mapFlag = false
      this.excelFlag = true;
      this.listFlag = false;
      return
    }

    this.mapFlag = false
    this.excelFlag = false;
    this.listFlag = true
  }
  excelFlag: boolean = false
  mapFlag: boolean = false
  listFlag: boolean = true
  async map(vale: string) {

    await this.resert(vale)

    this.allArea = []
    this.allArea.push({ zone_cd: undefined, word: undefined, mohalla: undefined });
    //  this.listDatasource=new MatTableDataSource([])
    //  this.listDatasource.paginator = this.paginator.toArray()[1];
    //  this.listDatasource.sort = this.sort.toArray()[1];
    this.obj = {}
    //  await this.cleanForm()
  }


  async cleanForm() {
    await this.form.resetForm();

  }

  deleteRow(i: any) {
    if (this.allArea.length > 1) {
      this.allArea.splice(i, 1)
    }
  }
  allArea: any = []
  add_row: number = 1
  add() {
    for (let j = 0; j < this.add_row; j++) {
      this.allArea.push({});
    }
  }
async submit() {
  let error = false;

  for (let i = 0; i < this.allArea.length; i++) {
    if ((Object.values(this.allArea[i]).filter((value: any) => value !== null && value !== undefined).length) < 3) {
      error = true;
      swal.fire('Error', 'Fill all required fields', 'error');
      break;
    }
    this.allArea[i]['zone'] = this.allZoneObj[this.allArea[i]['zone_cd']]['zone'];
    this.allArea[i]['leaf_cd'] = this.allZoneObj[this.allArea[i]['zone_cd']]['leaf_cd'];
  }

  if (error) {
    return;
  }

  let obj = {
    b_acct_id: this.ebillUser.b_acct_id,
    data: this.allArea,
    creater_user_id: this.ebillUser.le_id
  };

  let resp: any = await this.areaMap.areaMaping(obj);

  if (resp['error'] == false) {
    Swal.fire({
      title: 'Success!',
      text: 'Ward Mapping submitted successfully.',
      icon: 'success',
      confirmButtonText: 'OK'
    }).then(async (result) => {
      if (result.isConfirmed) {
        this.mapFlag = false;
        this.excelFlag = false;
        this.listFlag = true;
        $('.nav-tabs a[href="#tab-7-1"]').tab("show");  
        await this.getAreaMapData(); 
      }
    });
  } else {
    swal.fire('Error', "Error while creating", 'error');
  }
}


async submitExcel(form: any) {
  let obj = {
    b_acct_id: this.ebillUser.b_acct_id,
    data: this.listDatasource.filteredData,
    creater_user_id: this.ebillUser.le_id
  };

  let resp: any = await this.areaMap.areaMaping(obj);

  if (resp['error'] == false) {
    Swal.fire({
      title: 'Success!',
      text: resp['data'],
      icon: 'success',
      confirmButtonText: 'OK'
    }).then(async (result) => {
      if (result.isConfirmed) {
        await this.getAreaMapData();
        $('.nav-tabs a[href="#tab-7-1"]').tab("show");
        form.resetForm();
      }
    });
  } else {
    swal.fire('Error', "Error while creating check zone list", 'error');
  }
}



  /*-----------------Excel---------------------------*/




  export() {
    let ExpData = [{
      'one': 'Ward',
      'two': 'Mohalla',
    },
    ]
    var exp = []
    for (var i = 0; i < ExpData.length; i++) {
      var obj: any = new Object();
      obj['1'] = ExpData[i]['one']
      obj['2'] = ExpData[i]['two']
      exp.push(obj);
    }
    this.excel.exportAsExcelFile(exp, 'ZoneMapingFormat')

  }


  onClick(event: any) {
    event.target.value = '';
    this.listDatasource = new MatTableDataSource([])
  }


  async onFileChange(event: any) {
    /* wire up file reader */
    if (!this.obj['zone_cd']) {
      event.target.value = ''
      swal.fire('Please', 'Select Zone First', 'info');
      return;
    }
    const target: DataTransfer = <DataTransfer>(event.target);
    if (target.files.length !== 1) {
      throw new Error('Cannot use multiple files');
    }
    const reader: FileReader = new FileReader();
    reader.readAsBinaryString(target.files[0]);
    reader.onload = (e: any) => {
      const binarystr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(binarystr, { type: 'binary' });
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];
      const data = XLSX.utils.sheet_to_json(ws);
      data.splice(0, 1)
      data.map((x: any) => {
        x['word'] = x['1']
        x['mohalla'] = x['2']
        x['zone_cd'] = this.obj['zone_cd']
        x['zone'] = this.allZoneObj[x['zone_cd']]['zone']
        x['leaf_cd'] = this.allZoneObj[x['zone_cd']]['leaf_cd']

      })
      this.listDatasource = new MatTableDataSource(data)
      this.listDatasource.paginator = this.paginator.toArray()[1];
      this.listDatasource.sort = this.sort.toArray()[1];
    };


  }

  async deleteOpen(message: any, i: number) {
    Swal.fire({
      title: `${message}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Delete it!",
    }).then((result) => {
      if (result.value) {
        this.listDatasource.filteredData.splice(i, 1);
        this.listDatasource = new MatTableDataSource(this.listDatasource.filteredData)
        this.listDatasource.paginator = this.paginator.toArray()[1];
        this.listDatasource.sort = this.sort.toArray()[1];
      }
    });
  }

  /*------------------------------------------------*/
  selected: any = {}
  onEdit(modalRef: any, element: any): void {
    this.selected = element
    this.modalService.open(modalRef, { windowClass: 'modal-md-custom', size: 'lg', backdrop: 'static', centered: true });
  }

  async updateZoneMapping() {
    let obj: any = { b_acct_id: this.ebillUser.b_acct_id, id: this.selected.id, area_id: this.selected.area_id, status: 'UPDATED' }
    obj['zone'] = this.allZoneObj[this.selected['zone_cd']]['zone']
    obj['leaf_cd'] = this.allZoneObj[this.selected['zone_cd']]['leaf_cd']
    obj['zone_cd'] = this.selected['zone_cd']
    obj['word'] = this.selected['word']
    obj['mohalla'] = this.selected['mohalla']
    obj['creater_user_id'] = this.ebillUser.le_id
    obj['updater_user_id'] = this.ebillUser.le_id
    if (!obj['zone'].trim() && !obj['zone_cd'].trim() && !obj['word'].trim() && !obj['mohalla'].trim()) {
      swal.fire('Opps !!', 'Please Fill All required fields', 'info')
      return
    }
    this.tspinner.show('', '')
    let resp = await this.areaMap.updateAreaMaping(obj)
    if (resp['error'] == false) {
      await this.getAreaMapData()
      this.modalService.dismissAll();
      this.tspinner.hide()
      swal.fire('Success', resp['data'], 'success')
    } else {
      this.tspinner.hide()
      swal.fire('Opps !!', resp['data'], 'info')
    }

  }

  async deleteAreaMaping(element: any) {
    const result = await Swal.fire({
      title: 'Are you Sure !!',
      text: `After delete you can't retrive it?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Delete',
      cancelButtonText: 'Cancel',
      showLoaderOnConfirm: true,
    });

    if (!result.isConfirmed) {
      return
    }
    let obj: any = { b_acct_id: this.ebillUser.b_acct_id, id: element.id, area_id: element.area_id, status: 'DELETED' }
    obj['creater_user_id'] = this.ebillUser.le_id
    obj['updater_user_id'] = this.ebillUser.le_id
    this.tspinner.show('', '')
    let resp = await this.areaMap.deleteAreaMaping(obj)
    if (resp['error'] == false) {
      await this.getAreaMapData()
      this.modalService.dismissAll();
      this.tspinner.hide()
      swal.fire('Success', resp['data'], 'success')
    } else {
      this.tspinner.hide()
      swal.fire('Opps !!', resp['data'], 'info')
    }

  }
}